module.exports = __webpack_public_path__ + "img/calendar.7ac64cf2.svg";